import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import ArticlesList from '../components/ArticlesList';
import ArticlesHelmet from '../components/ArticlesHelmet';
import { AUTH_CONFIG } from '../config';

const Articles = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [searchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  
  // Check if user is authenticated as admin
  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        console.log("Checking authentication status in Articles page");
        const authenticated = await AUTH_CONFIG.isAuthenticated();
        console.log("Authentication result:", authenticated);
        setIsAdmin(authenticated);
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAdmin(false);
      }
    };
    
    checkAdminStatus();
  }, []);
  
  return (
    <div className="container mx-auto px-4 py-8">
      {/* SEO metadata - Add NOINDEX, FOLLOW for pagination pages */}
      <Helmet>
        {/* Only add canonical URL to main page (page 1) */}
        <link rel="canonical" href={window.location.origin + "/a/"} />
        
        {/* Add NOINDEX, FOLLOW for pagination pages (page > 1) */}
        {currentPage > 1 && (
          <meta name="robots" content="noindex, follow" />
        )}
        
        {/* Add prev link for pagination pages */}
        {currentPage > 1 && (
          <link 
            rel="prev" 
            href={`${window.location.origin}/a/${currentPage > 2 ? `?page=${currentPage - 1}` : ''}`} 
          />
        )}
        
      </Helmet>
      
      {/* We need access to pagination data to determine if there's a next page */}
      <ArticlesHelmet currentPage={currentPage} />
      
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold mb-2">Threats to Democracy: Articles</h1>
        <p className="text-gray-600 max-w-3xl mx-auto">
          Detailed analysis of news articles and statements with assessments of their impact on democratic values and institutions.
        </p>
      </div>
      
      {/* Articles list */}
      <ArticlesList isAdmin={isAdmin} />
    </div>
  );
};

export default Articles;